// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Actions
import { goTo } from 'store/reducers/navigation/actions';

// Selectors
import {
  getTotalPrice,
  getServicesCount,
  getServices,
  getDeclinedServices
} from 'store/reducers/appointment/selectors';
import { getPriceVisibility } from 'store/reducers/dealerSettings/selectors';
import { hasPromotion } from 'store/reducers/promotions/selectors';
import { getSelfCheckInFlow } from 'store/reducers/selfCheckIn/selectors';
import { showSCIProgressBar } from 'store/reducers/optimizelyABTest/selectors';

// Component
import ReviewServicesPage from './ReviewServicesPage';

const mapStateToProps = state => ({
  services: getServices(state).concat(getDeclinedServices(state)),
  servicesCount: getServicesCount(state),
  showPrice: getPriceVisibility(state)(),
  totalPrice: getTotalPrice(state),
  hasPromotion: hasPromotion(state),
  selfCheckInFlow: getSelfCheckInFlow(state),
  showSCIProgressBar: showSCIProgressBar(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo
    }
  )
)(ReviewServicesPage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ReviewServicesPage/ReviewServicesPageContainer.js